import { KeyboardEvent } from 'react'

import { TextArea, TextField } from '@joor/design-system'
import styled from 'styled-components'

import { Attachment } from '__generated__/atlas-types'

import { InvoiceAttachment } from 'features/Orders/Review/components/InvoiceAttachment/InvoiceAttachment'

const Container = styled.div`
  height: 300px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
`

type DetailsPage2Props = {
  orderId?: string
  emailSubject: string
  setEmailSubject: (emailSub: string) => void
  emailBody: string
  setEmailBody: (emailSub: string) => void
  attachment?: Attachment
  attachmentLoading?: boolean
  handleUploading: (attachment: Attachment) => void
  handleUpdateAttachmentLoading: (attachmentLoading: boolean) => void
  onDeleteAttachment: () => void
  dueDate: string
}

const handleKeyPress = (
  //TODO: move this code to the DS so it happens for all inputs/textareas
  event: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
  value: string,
): void => {
  if (event.code === 'Space' && value.length === 0) {
    event.preventDefault()
  }
}

const DetailsPage2 = ({
  orderId,
  emailSubject,
  setEmailSubject,
  emailBody,
  setEmailBody,
  attachment,
  attachmentLoading,
  handleUploading,
  handleUpdateAttachmentLoading,
  onDeleteAttachment,
  dueDate,
}: DetailsPage2Props) => {
  return (
    <Container>
      <TextField
        label="Email Subject"
        placeholder="Type subject line..."
        caption="Generic subject will generate if left blank."
        value={emailSubject}
        onChange={(e) => setEmailSubject(e.target.value)}
        maxLength={80}
        isRequired
        onKeyPress={(e) => handleKeyPress(e, emailSubject)}
      />
      <TextArea
        label="Email Body"
        placeholder="Type email content..."
        caption="Generic message will generate if left blank."
        value={emailBody}
        onChange={(e) => setEmailBody(e.target.value)}
        maxLength={500}
        isRequired
        onKeyPress={(e) => handleKeyPress(e, emailBody)}
      />
      <InvoiceAttachment
        orderId={orderId}
        attachment={attachment}
        attachmentLoading={attachmentLoading}
        handleUploading={handleUploading}
        handleUpdateAttachmentLoading={handleUpdateAttachmentLoading}
        onDeleteAttachment={onDeleteAttachment}
        dueDate={dueDate}
      />
    </Container>
  )
}

export default DetailsPage2
